import * as swcHelpers from '@swc/helpers';
import React__default, { forwardRef } from 'react';
import classnames from 'classnames';

const LineItem = /*#__PURE__*/ forwardRef((_param, ref)=> {
    var { className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className"
    ]);
    return React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('elements-line-item', className),
        ref: ref
    }));
});
LineItem.displayName = 'LineItem';
var LineItem$1 = LineItem;

export { LineItem$1 as default };
//# sourceMappingURL=LineItem.js.map
